@if (selected) {
  <app-selected-icon />
} @else {
  <app-icon name="selected-item-composition-background" />
}

